import React from 'react';

import Menu from 'controls/menu/Menu';
import Toolbar from 'components/tracks-tree/toolbar/Toolbar';
import View from 'components/tracks-tree/view/View';

export default function TracksTree () {
  return (
    <div>
      <Menu/>
      <Toolbar viewType='tree'/>
      <View/>
    </div>
  );
}
